import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'src/environments/environment';
import { User } from '../model/User.model';
import { AjaxService } from './ajax.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${API}/users`;

  constructor(private ajax: AjaxService) { }

  // Create new user
  createUser(user: User): Observable<User> {
    return this.ajax.post(this.apiUrl, user);
  }

  // Get all users
  getUsers(): Observable<User[]> {
    return this.ajax.get(this.apiUrl);
  }

  // Get user by ID
  getUserById(id: string): Observable<User> {
    return this.ajax.get(`${this.apiUrl}/${id}`);
  }

  // Update user
  updateUser(id: string, user: User): Observable<User> {
    return this.ajax.put(`${this.apiUrl}/${id}`, user);
  }

  // Delete user
  deleteUser(id: string): Observable<void> {
    return this.ajax.delete(`${this.apiUrl}/${id}`);
  }
} 